import { IconChevronsLeft } from "@tabler/icons-react";
import { IconChevronDown, IconChevronsRight } from "@tabler/icons-react";
import Select from "react-select";
import s from './calendar-input.module.scss'

export const CalendarHeader = ({
	date,
	changeYear,
	decreaseMonth,
	increaseMonth,
	prevMonthButtonDisabled,
	nextMonthButtonDisabled}) => {
  const years = range(1900, getYear(new Date()) + 1, 1).map((el => ({label: el, value: el})));
  const months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];

	function getYear(date) {
		const d = date
		return d.getFullYear();
	}

	function getMonth(date) {
		const d = date
		return d.getMonth();
	}

	function range(start, end, step = 1) {
		const result = [];
		for (let i = start; i < end; i += step) {
			result.push(i);
		}
		return result;
	}

  return (
		<div>
			<div
				className={s.headerWrapper}
			>
				<button onClick={(e) => {
					e.preventDefault()
					decreaseMonth()
				}} disabled={prevMonthButtonDisabled}>
					<IconChevronsLeft size={24} color="var(--text-secondary)"/>
				</button>
				{months[getMonth(date)] + ' - '}
				<Select
					defaultValue={years.find(el => el.value == getYear(date))}
					onChange={(el) => changeYear(el.value)}
					options={years}
					isSearchable={false}
					components={{
						DropdownIndicator: () => <IconChevronDown size={18}/>
					}}
					styles={{
						control: (baseStyles) => ({
							...baseStyles,
							minHeight: 0,
							padding: 0,
							border: 'none',
							backgroundColor: 'transparent',
							boxShadow: 'none',
							cursor: 'pointer',
						}),
						singleValue: (baseStyles) => ({
							...baseStyles,
							fontSize: 14,
							color: 'var(--text-primary)',
							fontFamily: 'Inter, sans-serif',
							padding: 0,
						}),
						valueContainer: (baseStyles)=> ({
							...baseStyles,
							padding: 0,
							paddingRight: 4,
						}),
						indicatorSeparator: () => ({
							display: 'none',
						}),
						dropdownIndicator: (baseStyles) => ({
							...baseStyles,
							padding: 0,
							color: 'var(--text-secondary)',
						}),
						menu: (baseStyles) => ({
							...baseStyles,
							backgroundColor: 'var(--bg-elevated)',
							border: '1px solid var(--border-default)',
							borderRadius: 8,
							overflow: 'hidden',
							zIndex: 30,
						}),
						option: (baseStyles, state) => ({
							...baseStyles,
							fontSize: 14,
							fontFamily: 'Inter, sans-serif',
							color: 'var(--text-primary)',
							backgroundColor: state.isFocused ? 'var(--primary-main-25, #FFF7F2)' : 'transparent',
							cursor: 'pointer',
						}),
					}}
					/>

				<button onClick={(e) => {
					e.preventDefault()
					increaseMonth()
				}} disabled={nextMonthButtonDisabled}>
					<IconChevronsRight size={24} color="var(--text-secondary)"/>
				</button>
			</div>
		</div>
  );
};
